<template>
  <div class="row justify-content-center g-4">
      <div v-for="(item, index) in location" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
          <GridLayout :item="item" :border="border" route-name="ExhibitSearch"/>
      </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, watch } from 'vue';
import axios from 'axios';
import GridLayout from './grid-layout.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  border: Boolean
});

const location = ref([]);
const { locale } = useI18n();

const fetchCountries = async () => {
  try {
      const response = await axios.get("/countries", {
          params: {
              lang: locale.value,
              limit: 6,              
              page: 1                
          }
      });

      location.value = response.data.data;
  } catch (error) {
      console.error("Error fetching countries:", error);
  }
};

onMounted(fetchCountries);
watch(locale, fetchCountries, { immediate: true });
</script>
